import {Event} from 'main.core';
import {InstancesManagerAsync} from 'asteq.instancesmanagerasync';

export class Formschemes extends Event.EventEmitter {
    static instances = new InstancesManagerAsync();

    constructor(options = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Forms.Formschemes');

        this.el = options.formId
            ? window[options.formId]
            : null;

        if(this.el instanceof HTMLCollection) {
            console.error('На странице расположены несколько форм с одинаковыми id');
            this.el = this.el[0];
        }

        this.modal = null;
        this.captcha = null;

        if (!this.el) {
            return;
        }

        this.form = this.el.tagName === 'FORM'
            ? this.el
            : this.el.querySelector('[data-form]');

        if (this.form) {
            this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        if (options.captcha) {
            this.initCaptcha(options.captcha);
        }

        this.errorsBlock = document.querySelector('[data-errors=' + this.getId() + ']');
        this.resultBlock = document.querySelector('[data-result=' + this.getId() + ']');

        if (options.modalId) {
            this.modal = BX.Asteq.Modalschemes.getInstance(options.modalId);
            if (this.modal) {
                this.modal.subscribe('open', this.onOpenModal.bind(this));
                this.modal.subscribe('close', this.onCloseModal.bind(this));
            }
        }

        this.constructor.addInstance(this.getId(), this);
    }

    initCaptcha(captchaOptions) {
        if (captchaOptions.type == 'bitrix') {
            BX.loadExt('asteq.forms.captcha.bitrixcaptcha').then(() => {
                this.captcha = new BX.Asteq.Forms.Captcha.BitrixCaptcha({
                    parent: this,
                    ...captchaOptions,
                });
            });
        } else if (captchaOptions.type == 'google') {
            BX.loadExt('asteq.forms.captcha.googlecaptcha').then(() => {
                this.captcha = new BX.Asteq.Forms.Captcha.GoogleCaptcha({
                    parent: this,
                    ...captchaOptions,
                });
            });
        }
    }

    getId() {
        return this.el?.id;
    }

    async send() {
        return new Promise(((resolve, reject) => {
            if (!this.form
                || !this.form.method
                || !this.form.action) {
                reject();
            }

            const method = this.form.method;
            const url = this.form.action;
            const formData = new FormData(this.form);
            const xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.send(formData);
            xhr.onload = () => {
                let jsonResponse = null;
                try {
                    jsonResponse = JSON.parse(xhr.response);
                } catch (ex) {
                    console.error('Не удалось распарсить json: ' + ex.message)
                }
                resolve({
                    xhr,
                    jsonResponse,
                });
            };
        }));
    }

    showErrorHtml(html) {
        if (!this.errorsBlock) {
            return;
        }

        if (!html) {
            this.errorsBlock.setAttribute('hidden', '');
            return;
        }

        this.errorsBlock.innerHTML = html;
        this.errorsBlock.removeAttribute('hidden');
    }

    showResult(html) {
        if (!this.resultBlock
            || !this.form) {
            return;
        }

        if (!html) {
            this.resultBlock.setAttribute('hidden', '');
            this.form.removeAttribute('hidden');
            return;
        }

        this.resultBlock.innerHTML = html;
        this.resultBlock.removeAttribute('hidden');
        this.form.setAttribute('hidden', '');
    }

    async submit() {
        if(this.captcha) {
            await this.captcha.prepareFormBeforeSend();
        }
        
        const sendResult = await this.send();
        const jsonResponse = sendResult.jsonResponse;

        if (!jsonResponse) {
            return;
        }

        if (jsonResponse.isSuccess) {
            this.showErrorHtml(null);

            if (jsonResponse.message) {
                this.showResult(jsonResponse.message);
            }

            if (this.form) {
                this.form.reset();
            }

        } else {
            if (jsonResponse.errorsHtml) {
                this.showErrorHtml(jsonResponse.errorsHtml);
            }
        }

        if (jsonResponse.captcha && this.captcha) {
            this.captcha.update(jsonResponse.captcha);
        }
    }

    applyValues(values = {}) {
        for (let code in values) {
            const inputEl = this.el.querySelector(`[data-code="${code}"]`);
            if (!inputEl) {
                continue;
            }

            inputEl.value = values[code];
        }
    }

    async onSubmit(e) {
        e.preventDefault();
        this.submit();
    }

    onOpenModal() {
        this.emit('shown');
    }

    onCloseModal() {
        this.showResult(null);
    }

    static addInstance(key, instance) {
        return this.instances.addInstance(key, instance);
    }

    static async getInstanceAsync(key) {
        return this.instances.getInstanceAsync(key);
    }
    
    static getInstance(key) {
        return this.instances.getInstance(key);
    }
}